// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2YCez","amount":"Amount_amount__1V8pZ","tip":"Amount_tip__2YgrV","tipHeader":"Amount_tipHeader__3HbuG","tipsWrap":"Amount_tipsWrap__1smmM"};